module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "bestsell4.350e60f7.jpeg" + "?" + Date.now();